function toggleMiniCart() {
  const buttonsToOpenCart = document.querySelectorAll('a[href="#mini-cart"]');
  const miniCart = document.getElementById("mini-cart");

  if (!buttonsToOpenCart) return;

  buttonsToOpenCart.forEach((button) => {
    button.addEventListener("click", (e) => {
      miniCart.classList.toggle("active");
    });
  });
}

export { toggleMiniCart };
